import { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import { authService } from '../services/authService';

export const useUserProfile = () => {
    const { user } = useContext(AuthContext);
    const [userProfile, setUserProfile] = useState(null);
    const [profileLoading, setProfileLoading] = useState(true);

    // Charger le profil
    useEffect(() => {
        const fetchProfile = async () => {
            try {
                if (!user) {
                    setUserProfile(null);
                    setProfileLoading(false);
                    return;
                }

                const profile = await authService.getUserData(user.uid);
                setUserProfile(profile);

            } catch (error) {
                console.error('[useUserProfile] Erreur:', error);
                setUserProfile(null);
            } finally {
                setProfileLoading(false);
            }
        };

        fetchProfile();
    }, [user]);

    // Mettre à jour le profil
    const updateProfile = async (data) => {
        try {
            if (!user) throw new Error('Utilisateur non connecté');

            // Mettre à jour Firestore
            const { doc, updateDoc, serverTimestamp } = await import('firebase/firestore');
            const { db } = await import('../config/firebase');

            const userDocRef = doc(db, 'users', user.uid);
            await updateDoc(userDocRef, {
                name: data.name,
                phone: data.phone,
                updatedAt: serverTimestamp(),
            });


            // Recharger le profil
            const updatedProfile = await authService.getUserData(user.uid);
            setUserProfile(updatedProfile);
        } catch (error) {
            console.error('[useUserProfile] Erreur mise à jour:', error);
            throw error;
        }
    };

    return {
        userProfile,
        profileLoading,
        updateProfile,
    };
};
